import { CONTACT } from "../../data/boats";
import { MapPin, ArrowRight } from "lucide-react";

export default function LocationSection() {
  const mapSrc = "https://www.google.com/maps?q=Inner+Lakes+Marina+Killinure+Athlone&output=embed";

  return (
    <section id="location" data-testid="location-section" className="bg-[#FAFAF8]">

      {/* Full-bleed map */}
      <div className="relative w-full h-[50vh] border-y border-[#1C1C1A]/10">
        <iframe
          title="Inner Lakes Marina map"
          src={mapSrc}
          width="100%"
          height="100%"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0 w-full h-full grayscale"
          data-testid="location-map-iframe"
        />
        {/* Overlay label */}
        <div className="absolute bottom-6 left-6 sm:left-10 lg:left-16 bg-[#FAFAF8] px-5 py-4 border border-[#1C1C1A]/10 max-w-xs">
          <div className="flex items-start gap-3">
            <MapPin size={14} className="mt-0.5 text-[#C8A96E] shrink-0" strokeWidth={1.5} />
            <div>
              <p className="font-medium text-[#1C1C1A] text-sm">Inner Lakes Marina</p>
              <p className="text-xs text-[#6B6B65] mt-0.5">Killinure, Athlone · Co. Westmeath, Ireland</p>
            </div>
          </div>
        </div>
      </div>

      {/* Info row */}
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-5">Where you'll be</p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light text-[#1C1C1A] tracking-tight leading-tight">
              Inner Lakes Marina,<br />
              <em className="italic">Lough Ree.</em>
            </h2>
            <p className="mt-7 text-[#6B6B65] leading-relaxed font-light text-sm">
              The marina sits on the eastern shore of Lough Ree, within easy reach of Athlone town. Marina access codes are shared prior to arrival. Take extra care when boarding from the pontoons.
            </p>
            <a
              href="https://www.google.com/maps?q=Inner+Lakes+Marina+Killinure+Athlone"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-map-link"
              className="link-arrow mt-8 inline-flex"
            >
              Open in Google Maps <ArrowRight size={12} />
            </a>
          </div>

          {/* Distances */}
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="eyebrow mb-6">Nearby</p>
            <div className="space-y-0">
              {[
                { place: "The Chalets Restaurant", dist: "1 km" },
                { place: "Glasson LakeHouse Hotel", dist: "1.5 km" },
                { place: "Glasson Village", dist: "2 km" },
                { place: "Athlone Town Centre", dist: "12 km" },
                { place: "Dublin", dist: "120 km" },
              ].map((item) => (
                <div key={item.place} className="flex items-center justify-between py-4 border-b border-[#1C1C1A]/8">
                  <span className="text-sm text-[#1C1C1A]">{item.place}</span>
                  <span className="text-xs text-[#6B6B65] uppercase tracking-wider">{item.dist}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
